import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Convert a stored wall-clock datetime (naive UTC) to the actual UTC instant
 * for a given timezone. Mirrors the backend's wallClockToUTC function.
 */
export const wallClockToUTC = (dateStr: string, timezone: string): Date => {
  const d = new Date(dateStr);
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(d);
  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value;
  const localStr = `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}.000Z`;
  const localAsUTC = new Date(localStr);
  const offsetMs = localAsUTC.getTime() - d.getTime();
  return new Date(d.getTime() - offsetMs);
};
